import { apiClient } from "@/services/api";

export interface StoreFromAPI {
	id: string;
	name: string;
	slug: string;
	faviconUrl?: string;
	role?: "owner" | "admin" | "manager" | "support" | "viewer";
}

export const getStoresAdapter = async (): Promise<StoreFromAPI[]> => {
	const response = await apiClient.get<
		| StoreFromAPI[]
		| {
				stores?: StoreFromAPI[];
				data?: StoreFromAPI[];
		  }
	>("/stores/all");

	const data = response.data;
	const storesList = Array.isArray(data)
		? data
		: data.stores || data.data || [];

	return storesList;
};
